import React, {
  FC, useState,
} from 'react';
import Header from '../../../../Common/Header';
import Logo from '../../../../Common/Logo';
import PlatformLayout from '../../../../Common/PlatformLayout';
import DividerLine from '../../../../../../components/DividerLine';
import SquadRegularText from '../../../../../../components/Text/SquadRegularText';
import PingFangRegularText from '../../../../../../components/Text/PingFangRegularText';
import BackgroundImage from '../../../../../../components/BackgroundImage';
import SearchUser from '../SearchUser';

const SelectPlatform: FC<Props> = ({
  cabId32Str,
  isEnglish,
  setIsEnglish,
  setShowLoading,
  driverId,
  smallCabId,
  largeCabId,
  onClose,
}) => {
  // 当前选择的平台
  const [selectedPlatform, setSelectedPlatform] = useState<number>();
  return (
    <BackgroundImage>
      {
        !selectedPlatform && (
          <>
            {/* 头部 */}
            <Header
              isEnglish={isEnglish}
              setIsEnglish={setIsEnglish}
              style={{ marginTop: 20 }}
              supportIsOnlyCall={true}
              cabId32Str={cabId32Str}
            />

            {/* Logo */}
            <Logo onClose={onClose} backToPage={'home'} />

            {/* 分隔线 */}
            <DividerLine width={266} backgroundColor={'#11202B'} opacity={0.157} marginLeft={'auto'} marginRight={'auto'} marginTop={25} />

            {/* 标题 */}
            {
              isEnglish ? (
                <SquadRegularText fontSize={20} lineHeight={21} textAlign={'center'} marginTop={26}>
                  Select your platform
                </SquadRegularText>
              ) : (
                <PingFangRegularText fontSize={20} lineHeight={21} textAlign={'center'} marginTop={26}>
                  请选择您的配送平台
                </PingFangRegularText>
              )
            }

            {/* 商家列表 */}
            <PlatformLayout isEnglish={isEnglish} callback={setSelectedPlatform} />
          </>
        )
      }

      {
        selectedPlatform && (
          <SearchUser
            cabId32Str={cabId32Str}
            selectedPlatform={selectedPlatform}
            isEnglish={isEnglish}
            setIsEnglish={setIsEnglish}
            setShowLoading={setShowLoading}
            driverId={driverId}
            largeCabId={largeCabId}
            smallCabId={smallCabId}
            onClose={onClose}
            setSelectedPlatform={setSelectedPlatform}
          />
        )
      }
    </BackgroundImage>
  );
};

export interface Props {
  cabId32Str: string;
  isEnglish: boolean;
  setIsEnglish: (isEng: boolean) => void;
  setShowLoading: (isShow: boolean) => void;
  driverId: number;
  // 大小柜组合时，小柜柜子ID和大柜柜子ID
  smallCabId?: number;
  largeCabId?: number;
  onClose: () => void;
}

export default SelectPlatform;
